import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgVitaminCGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M39.36 29.3c-.4-.06-.79.22-.85.63-.86 5.64-3.12 9.57-5.51 9.57-2.84 0-5.87-5.83-5.87-14.5S30.16 10.5 33 10.5c2.37 0 4.63 3.9 5.5 9.49.06.41.45.69.86.63.41-.06.69-.45.63-.86C38.97 13.22 36.23 9 33 9c-4.13 0-7.37 7.03-7.37 16 0 8.97 3.24 16 7.37 16 3.25 0 5.99-4.26 6.99-10.85a.747.747 0 0 0-.63-.85ZM14.79 18.21a.761.761 0 0 0 1.16 0l6.62-7.98c.26-.32.22-.79-.1-1.06a.758.758 0 0 0-1.06.1l-6.04 7.28-6.04-7.28a.757.757 0 0 0-1.06-.1c-.32.26-.36.74-.1 1.06l6.62 7.98ZM15.37 20.26c-.41 0-.75.34-.75.75v7.98c0 .41.34.75.75.75s.75-.34.75-.75v-7.98c0-.41-.33-.75-.75-.75ZM21.99 31.52H8.75c-.41 0-.75.34-.75.75s.34.75.75.75h5.87v7.23c0 .41.34.75.75.75s.75-.34.75-.75v-7.23h5.87a.749.749 0 1 0 0-1.5Z",
    fill: "currentColor"
  }));
}

export { SvgVitaminCGlyphSecondary as default };
